import uniqBy from 'lodash/uniqBy'

import type { NativeTag, NativeTagWithCategory } from 'types/track'

export const getCategoriesAndTags = (
  filteredTags: NativeTagWithCategory[],
  value?: number[],
): { [key: string]: NativeTag[] } => {
  const tagGroups: { [key: string]: NativeTag[] } = {}
  const categories = uniqBy(
    filteredTags.map(tag => tag.category),
    'id',
  )
  categories.forEach(category => {
    const tags =
      filteredTags
        .filter(tag => tag.category_id === category.id)
        .filter(tag => !value?.includes(tag.id)) || []

    if (tags.length > 0) {
      tagGroups[category.name] = tags
    }
  })
  return tagGroups
}

export const getMatchingTagCategories = (
  searchValue: string,
  filteredTags: NativeTagWithCategory[],
) => {
  if (!searchValue || !filteredTags?.length) return []

  return uniqBy(
    filteredTags
      .filter(tag => tag.name.toLowerCase().includes(searchValue))
      .map(tag => tag.category.name),
    name => name,
  )
}

export const getFilteredSelectedTags = (
  value: number[] | undefined,
  searchValue: string,
  allTags: NativeTagWithCategory[],
): NativeTag[] => {
  if (!value) return []
  const selectedTags = allTags.filter(tag => value.includes(tag.id))
  if (!searchValue) return selectedTags
  return selectedTags.filter(tag =>
    tag.name.toLowerCase().includes(searchValue.toLowerCase()),
  )
}
